import React from "react";
import Navbar from "../components/navbar";
import Hero from "../components/hero";
import Footer from "../components/footer";
import "../styles/universal.css";
import "../styles/feesPage.css";

const FeesPage = () => {
  return (
    <div className="fees-page">
      <Navbar />
      <Hero
        title="Fees"
        subtitle="Transparent pricing for counselling services and assessment packages."
      />

      <div className="fees-underlay">
        <div className="fees-container">
          <div className="fees-box">
            <p className="fees-header">Payment Information</p>
            <h1 className="fees-title">Fees / Rates</h1>

            <div className="fees-content">
              <h2>Individual and Virtual Counselling Sessions</h2>
              <ul>
                <li>
                  The fee for a 50 minute session is <strong>R650.00</strong>
                </li>
                <li>
                  Payments are accepted through medical aid, electronic funds
                  transfer (EFT) or card payment.
                </li>
              </ul>

              <h2>Psychometric Assessment</h2>
              <ul>
                <li>
                  Fee includes the introductory screening session, the
                  assessment, an individual report and feedback session.
                </li>
              </ul>

              <h2>Subject Choice Package</h2>
              <ul>
                <li>
                  The rate for a subject choice package for{" "}
                  <strong>R2000.00</strong>
                </li>
                <li>
                  Fees includes the introductory screening session, the
                  psychometric assessment, an individual report and feedback
                  session.
                </li>
              </ul>

              <h2>Career Assessment Package</h2>
              <ul>
                <li>
                  The rate for a career assessment package for 2026 is{" "}
                  <strong>R2800.00</strong>
                </li>
                <li>
                  Fees includes the introductory screening session, the
                  psychometric assessment, an individual report and feedback
                  session.
                </li>
              </ul>

              <div className="fees-section">
                <p>
                  <strong>Medical Aid:</strong> Should you wish for us to claim
                  directly from your medical aid, any shortfalls will be charged
                  as co-payments, which will be for a client&#39;s own account.
                  Clients remain responsible for accounts if not covered by
                  medical aid,and as such, it is recommended that you enquire
                  regarding the availability of sufficient funds prior to
                  initiating counselling.
                </p>
              </div>

              <div className="fees-section">
                <p>
                  <em>Please Note:</em> All private accounts are to be settled
                  directly after sessions. If medical aid claims are rejected,
                  the account is to be settled within 14 days of notice given.
                  After 30 days, accounts will be handed over for debt
                  collection by a third party. Note that debt collection
                  companies&#39; fees are charged in addition to the outstanding
                  account.
                </p>
              </div>

              <div className="fees-section">
                <p>
                  <em>Cancellations:</em> Please allow at least 24 hours&#39;
                  notice when cancelling a session. Sessions cancelled without
                  24 hour notice, or missed sessions, will be charged for{" "}
                  <strong>in full</strong>. The reason for this is that we would
                  be reserving a space for you, which could have been offered to
                  another person in need. Medical aids do not cover for missed
                  sessions, and as such, accounts will be sent directly to the
                  client Cancellations and re-scheduling can easily be managed
                  via WhatsApp or a phone call.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FeesPage;
